<script>
import mixinComponent from '../../Mixins/mixinComponent'
import { globalVariablesMixin } from '../../Mixins/global'
import ModalDialog from '../UI/Modal/ModalDialog.vue'
import FormCreator from '../UI/Form/FormCreator.vue'
import FieldCreator from '../UI/Form/FieldCreator.vue'
import ButtonAll from '../UI/Button/ButtonAll.vue'
import { PERIODICITY_MAP } from '../../Constants/Periodicity'
import ButtonAllNotReadonly from '../UI/Button/ButtonAllNotReadonly.vue'

export default {
  components: { ButtonAll, FieldCreator, FormCreator, ModalDialog, ButtonAllNotReadonly },
  mixins: [mixinComponent, globalVariablesMixin],

  props: {
    rentId: { type: Number, required: true },
    decisionId: { type: Number, required: false },
    hasServiceLevel: { type: Boolean, default: false },
    inContract: { type: Boolean, default: false },
    marginCalculationMethod: { type: String, required: true },
  },

  data() {
    return {
      def: {},
      rent: {},
      params: {},
      loadForm: false,
      loadField: false,
      sending: null,
      sendingCalcul: null,
      sendingInitialize: false,
      sendingLevel: false,
      loading: false,
      errorMessage: '',
      levelField: [],
      level: {
        finalOutstanding: 0,
        finalPercentOutstanding: 0,
        id: null,
        duration: null,
        amount: null,
        amountService: null,
        number: 0,
        invoiceType: 'RENT',
      },
      freeLevel: null,
      firstLevel: null,
      lastLevel: null,
      lastLevelAmount: null,
      lastLevelAmountService: null,
      activeLevel: false,
      formModel: {
        amount: {
          label: null,
          mainType: 'number',
          options: {
            constraints: { step: 'any', pattern: '^\d*(\.\d{0,2}|\,\d{0,2})?$', min: 0 },
            disabled: false,
            display: true,
            placeholder: null,
            required: false,
          },
          type: 'number',
        },
        amountService: {
          label: null,
          mainType: 'number',
          options: {
            constraints: { step: 'any', pattern: '^\d*(\.\d{0,2}|\,\d{0,2})?$', min: 0 },
            disabled: false,
            display: true,
            placeholder: null,
            required: false,
          },
          type: 'number',
        },
        duration: {
          label: null,
          mainType: 'number',
          options: {
            constraints: { step: 1, min: 1 },
            disabled: false,
            display: true,
            placeholder: null,
            required: false,
          },
          type: 'number',
        },
        number: {
          label: null,
          mainType: 'number',
          options: {
            constraints: { step: 1, min: 1 },
            disabled: false,
            display: true,
            placeholder: null,
            required: false,
          },
          type: 'number',
        },
      },
      formData: null,
    }
  },

  computed: {
    profitabilityClass() {
      const value = this.rent.profitability !== null ? this.rent.profitability : 0
      return value < 0 ? 'text-danger' : 'text-success'
    },
  },

  methods: {
    updateData(newData) {
      this.formData = newData
    },
    closeModal() {
      this.loadForm = false
      this.loadField = false
      this.$refs[`modal-rent-calculator${this.rentId}`].close(false)
    },
    showForm() {
      this.loadForm = true
      this.$refs[`modal-rent-calculator${this.rentId}`].open()
    },
    setSpecificLevel(level) {
      switch (level.invoiceType) {
        case 'LAST':
          this.lastLevel = level
          this.lastLevelAmount = level.amount
          if (this.hasServiceLevel) {
            this.lastLevelAmountService = level.amountService
          }
          break
        case 'FREE':
          this.freeLevel = level
          break
        case 'FIRST':
          this.firstLevel = level
          break
      }
    },
    globalBuild(data) {
      if (data.build === true) {
        this.loadField = data.build
        this.addValue(this.def, data.def)
        this.addValue(this.rent, data.object)

        this.activeLevel = this.activeLevel ? true : this.rent.formLevels.length >= 1

        if (this.rent.levels.length > 0) {
          this.rent.levels.map((level, index) => {
            this.setSpecificLevel(level)
          })
        }

        this.level.number = this.rent.formLevels.length
        if (this.level.number === 0) {
          this.postLevel()
        }
      }
    },
    isLoading(bool) {
      this.loading = bool
    },
    isSending(bool) {
      if (this.sending === 'initialize') {
        this.sendingInitialize = bool
      } else {
        this.sendingLevel = bool
      }
    },
    backToRent() {
      this.activeLevel = !this.activeLevel
      this.sending = 'initialize'
      this.$refs.formrent.datas['initialize'] = true
    },
    patchRent() {
      const maxDuration =
        this.rent.duration -
        this.rent.levels.reduce(
          (duration, level) => (level.invoiceType === 'FIRST' ? duration + level.duration : duration),
          1,
        )

      const periodicityMonths = PERIODICITY_MAP[this.rent.periodCode] || 1

      let totalDuration = 0
      let errorMessages = []

      if (this.$refs.formrent.datas.formLevels) {
        for (const level of this.$refs.formrent.datas.formLevels) {
          if (!level.number && level.number !== 0) {
            errorMessages.push(this.$t('rent.fields.level.number.missing'))
            break
          }
          if (!(level.number >= 1 && level.number < 100)) {
            errorMessages.push(this.$t('rent.fields.level.number.outOfRange'))
            break
          }
          if (!level.duration && level.duration !== 0) {
            errorMessages.push(this.$t('rent.fields.level.duration.missing'))
            break
          }
          if (!(level.duration >= 1)) {
            errorMessages.push(this.$t('rent.fields.level.duration.tooLow'))
            break
          }
          totalDuration += level.duration * periodicityMonths
          if (!level.amount && level.amount !== 0) {
            errorMessages.push(this.$t('rent.fields.level.amount.missing'))
            break
          }
          if (!(level.amount >= 0)) {
            errorMessages.push(this.$t('rent.fields.level.amount.tooLow'))
            break
          }
          if (level.amountService && !(level.amountService >= 0)) {
            errorMessages.push(this.$t('rent.fields.level.amountService.tooLow'))
            break
          }
        }
      }

      if (totalDuration > maxDuration) {
        const maxTerms = Math.floor(maxDuration / periodicityMonths)
        errorMessages.push(this.$t('rent.fields.level.duration.tooHigh', { max: maxTerms }))
      }

      if (this.lastLevelAmount && this.lastLevel.modify) {
        this.$refs.formrent.datas['lastLevelAmount'] = this.lastLevelAmount
        this.$refs.formrent.datas['modify'] = true
      } else {
        this.$refs.formrent.datas['modify'] = false
      }

      if (this.lastLevelAmountService && this.hasServiceLevel) {
        this.$refs.formrent.datas['lastLevelAmountService'] = this.lastLevelAmountService
      }

      this.errorMessage = errorMessages[0] ?? ''
      if (!this.errorMessage) {
        this.$refs.formrent.datas['isLevel'] = true
        this.$refs.formrent.methods('patch')
      }
    },
    setRent(json) {
      this.setValue(this.$refs.formrent.def, 'formLevels', json.config.formLevels)
      this.setValue(this.$refs.formrent.object, 'formLevels', json.rent.formLevels)

      json.rent.levels.map((level, index) => {
        this.setSpecificLevel(level)
      })

      this.setValue(this, 'rent', json.rent)
      this.$emit('set-level', { rent: json.rent })
    },
    setLevelField(obj) {
      this.setValue(this.rent.formLevels[obj.index], obj.name, obj.value)
      this.setValue(this.$refs.formrent.object.formLevels[obj.index], obj.name, obj.value)
    },
    postLevel() {
      //pour définir la construction de la config du form
      if (
        typeof this.$refs.formrent.def.formLevels == 'object' &&
        this.$refs.formrent.def.formLevels['label'] !== undefined
      ) {
        for (var key in this.$refs.formrent.def.formLevels) delete this.$refs.formrent.def.formLevels[key]
        this.setValue(this.$refs.formrent.def.formLevels, 0, { ...this.formModel })
      } else {
        this.$refs.formrent.def.formLevels[this.level.number] = this.formModel
      }

      this.rent.formLevels ??= {}
      this.$refs.formrent.object.formLevels ??= {}

      //pour définir les valeurs du form
      if (this.level.number === 0) {
        this.level.number++
        this.setValue(this.rent.formLevels, 0, { ...this.level })
        this.setValue(this.$refs.formrent.object.formLevels, 0, { ...this.level })
      } else {
        this.level.number++
        this.setValue(this.rent.formLevels, this.level.number - 1, { ...this.level })
        this.setValue(this.$refs.formrent.object.formLevels, this.level.number - 1, { ...this.level })
      }
    },
    deleteLevel(index, level) {
      this.level.number--

      this.rent.formLevels = this.rent.formLevels
        .filter((level, currentIndex) => currentIndex !== index)
        .map((level, index) => Object.assign(level, { number: index + 1 }))

      this.$refs.formrent.datas.formLevels = this.$refs.formrent.datas.formLevels
        .filter((level, currentIndex) => currentIndex !== index)
        .map((level, index) => Object.assign(level, { number: index + 1 }))

      this.$refs.formrent.object.formLevels = this.$refs.formrent.object.formLevels
        .filter((level, currentIndex) => currentIndex !== index)
        .map((level, index) => Object.assign(level, { number: index + 1 }))
    },
    editLastLevel() {
      this.lastLevel.modify = !this.lastLevel.modify
    },
    calculate() {
      this.sendingCalcul = true
      let datas = this.$refs.formrent.datas

      let filteredData = {}
      for (const [key, value] of Object.entries(datas)) {
        if (value !== '') {
          filteredData[key] = value
        }
      }

      filteredData = this.$refs.formrent.valueAsArray(filteredData)

      this.patchJSON(`decisions/${this.decisionId}/rents/${this.rent.duration}`, filteredData).then((json) => {
        this.sendingCalcul = false
        this.$emit('rent-updated', json)
        this.setValue(this, 'rent', json)
        this.setValue(this.$refs.formrent, 'object', json)
        this.resetLevel()
      })
    },
    calculateContract() {
      this.sendingCalcul = true
      this.$refs.formrent.datas['modify'] = false
      let datas = this.$refs.formrent.datas

      let filteredData = {}
      for (const [key, value] of Object.entries(datas)) {
        if (value !== '') {
          filteredData[key] = value
        }
      }

      this.patchJSON(`rents/${this.rent.id}`, filteredData).then((json) => {
        this.sendingCalcul = false
        this.$emit('rent-updated', json.rent)
        this.setValue(this, 'rent', json.rent)
        this.setValue(this.$refs.formrent, 'object', json.rent)
      })
    },
    activeLevelBtn() {
      this.sending = 'level'
      this.activeLevel = !this.activeLevel
      delete this.$refs.formrent.datas['initialize']
    },
    resetLevel() {
      this.level = {
        finalOutstanding: 0,
        finalPercentOutstanding: 0,
        id: null,
        duration: null,
        amount: null,
        amountService: null,
        number: 0,
        invoiceType: 'RENT',
      }

      this.postLevel()
    },
  },
}
</script>
<template>
  <ModalDialog
    :id="'modal-rent-calculator' + rentId"
    :ref="'modal-rent-calculator' + rentId"
    id-modal-page="page-devis"
    class-modal-dialog="modal-lg mw-100 w-75"
    e2e-modal="modal-rent-calculator"
    @icon-close="closeModal"
  >
    <FormCreator
      v-if="loadForm"
      ref="formrent"
      :id="rentId"
      endpoint="rents"
      method="patch"
      :params="{ id: rentId }"
      send-params
      class-to-add="d-none"
      @update-data="updateData"
      @global-build="globalBuild"
      @form-return="setRent"
      @is-loading="isLoading"
      @is-sending="isSending"
    />

    <template v-if="!loading && loadField" #body>
      <div class="row border-bottom mb-3 pb-3">
        <div class="col-md-6">
          <FieldCreator
            :form-data="formData"
            name="finance.residualPercent"
            form-ref="formrent"
            domain="rent"
            label="simulation.fields.finance.residualPercent.label"
            type-value="float"
            label-top
          />
          <FieldCreator
            :form-data="formData"
            name="finance.residualValue"
            form-ref="formrent"
            domain="rent"
            label="simulation.fields.finance.residualValue.label"
            label-top
          />
        </div>
        <div class="col-md-6">
          <FieldCreator
            :form-data="formData"
            name="finance.coeffMargin"
            form-ref="formrent"
            domain="rent"
            label="simulation.fields.finance.coeffMargin.label"
            label-top
          />
        </div>
      </div>
      <div class="row border-bottom mb-3 pb-3">
        <div class="col-md-6">
          <FieldCreator :form-data="formData" name="purchaseRate" form-ref="formrent" domain="rent" label-top />
        </div>
        <div class="col-md-6">
          <FieldCreator
            :form-data="formData"
            :name="marginCalculationMethod === 'RATE_SPREAD' ? 'rateSpread' : 'majoration'"
            form-ref="formrent"
            domain="rent"
            label-top
          />
        </div>
      </div>
      <div class="row">
        <div :class="activeLevel ? 'col-md-8' : 'col-md-6'">
          <div v-if="activeLevel">
            <table class="table table-bordered fs-16">
              <thead class="table-disabled">
                <tr class="table-disabled">
                  <th>{{ $t('rent.fields.level.number.label') }}</th>
                  <th>{{ $t('rent.fields.level.duration.label') }}</th>
                  <th>{{ $t('rent.fields.level.amount.label') }}</th>
                  <th v-if="hasServiceLevel">{{ $t('rent.fields.level.amountService.label') }}</th>
                  <th>{{ $t('simulation.fields.period.label') }}</th>
                  <th colspan="2">{{ $t('level.finalOutstanding.title') }}</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th>{{ $t('rent.fields.level.amount.value') }}</th>
                  <th v-if="hasServiceLevel">{{ $t('rent.fields.level.amountService.value') }}</th>
                  <th></th>
                  <th>{{ $t('level.finalOutstanding.value') }}</th>
                  <th>{{ $t('level.finalOutstanding.percent') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-disabled" v-if="freeLevel">
                  <td class="table-disabled table-cell-centered"></td>
                  <td class="table-disabled table-cell-centered">{{ freeLevel.duration }}</td>
                  <td class="table-disabled table-cell-centered">{{ $n(Number(freeLevel.amount), 'decimal') }}</td>
                  <td v-if="hasServiceLevel" class="table-disabled table-cell-centered">
                    {{ $n(Number(freeLevel.amountService), 'decimal') }}
                  </td>
                  <td class="table-disabled table-cell-centered">{{ rent.periodName }}</td>
                  <td class="table-disabled table-cell-centered">
                    {{ freeLevel.finalOutstanding > 0 ? $n(Number(freeLevel.finalOutstanding), 'decimal') : 0 }}
                  </td>
                  <td class="table-disabled table-cell-centered">
                    {{
                      freeLevel.finalPercentOutstanding > 0
                        ? $n(Number(freeLevel.finalPercentOutstanding), 'decimal')
                        : 0
                    }}
                  </td>
                  <td class="table-disabled table-cell-centered"></td>
                </tr>
                <tr class="table-disabled" v-if="firstLevel">
                  <td class="table-disabled table-cell-centered"></td>
                  <td class="table-disabled table-cell-centered">{{ firstLevel.duration }}</td>
                  <td class="table-disabled table-cell-centered">{{ $n(Number(firstLevel.amount), 'decimal') }}</td>
                  <td v-if="hasServiceLevel" class="table-disabled table-cell-centered">
                    {{ $n(Number(firstLevel.amountService), 'decimal') }}
                  </td>
                  <td class="table-disabled table-cell-centered">{{ rent.periodName }}</td>
                  <td class="table-disabled table-cell-centered">
                    {{ firstLevel.finalOutstanding > 0 ? $n(Number(firstLevel.finalOutstanding), 'decimal') : 0 }}
                  </td>
                  <td class="table-disabled table-cell-centered">
                    {{
                      firstLevel.finalPercentOutstanding > 0
                        ? $n(Number(firstLevel.finalPercentOutstanding), 'decimal')
                        : 0
                    }}
                  </td>
                  <td class="table-disabled table-cell-centered"></td>
                </tr>
                <tr v-for="(level, index) in rent.formLevels" :key="index">
                  <td>
                    <FieldCreator
                      :form-data="formData"
                      name="number"
                      :collection-index="index"
                      collection-name="formLevels"
                      form-ref="formrent"
                      domain="level"
                    />
                  </td>
                  <td>
                    <FieldCreator
                      :form-data="formData"
                      name="duration"
                      :collection-index="index"
                      collection-name="formLevels"
                      form-ref="formrent"
                      domain="level"
                      @collection-value="setLevelField"
                    />
                  </td>
                  <td>
                    <FieldCreator
                      :form-data="formData"
                      name="amount"
                      :collection-index="index"
                      collection-name="formLevels"
                      form-ref="formrent"
                      domain="level"
                      @collection-value="setLevelField"
                    />
                  </td>
                  <td v-if="hasServiceLevel">
                    <FieldCreator
                      :form-data="formData"
                      name="amountService"
                      :collection-index="index"
                      collection-name="formLevels"
                      form-ref="formrent"
                      domain="level"
                      @collection-value="setLevelField"
                    />
                  </td>
                  <td class="table-disabled table-cell-centered">{{ rent.periodName }}</td>
                  <td class="table-disabled table-cell-centered">
                    {{ level.finalOutstanding > 0 ? $n(Number(level.finalOutstanding), 'decimal') : 0 }}
                  </td>
                  <td class="table-disabled table-cell-centered">
                    {{ level.finalPercentOutstanding > 0 ? $n(Number(level.finalPercentOutstanding), 'decimal') : 0 }}
                  </td>
                  <td class="table-disabled table-cell-centered">
                    <ButtonAllNotReadonly
                      type="danger"
                      label="level.button.delete"
                      margin="no"
                      :disabled="rent.hasSimulationContract"
                      @click="deleteLevel(index, level)"
                    />
                  </td>
                </tr>
                <tr style="height: 40px"></tr>
                <tr class="table-disabled">
                  <td class="table-disabled table-cell-centered"></td>
                  <td class="table-disabled table-cell-centered">{{ lastLevel.duration }}</td>
                  <td class="table-disabled table-cell-centered">
                    <div v-if="!lastLevel.modify">{{ $n(Number(lastLevel.amount), 'decimal') }}</div>
                    <div v-else>
                      <input
                        id="lastLevelAmount"
                        step="any"
                        pattern="^d*(.d{0,2}|,d{0,2})?$"
                        v-model="lastLevelAmount"
                        type="number"
                        class="form-control"
                        :disabled="rent.hasSimulationContract"
                      />
                    </div>
                  </td>
                  <td v-if="hasServiceLevel" class="table-disabled table-cell-centered">
                    <input
                      id="lastLevelAmountService"
                      step="any"
                      pattern="^d*(.d{0,2}|,d{0,2})?$"
                      v-model="lastLevelAmountService"
                      type="number"
                      class="form-control"
                      :disabled="rent.hasSimulationContract"
                    />
                  </td>
                  <td class="table-disabled table-cell-centered">{{ rent.periodName }}</td>
                  <td class="table-disabled table-cell-centered">
                    {{ lastLevel.finalOutstanding > 0 ? $n(Number(lastLevel.finalOutstanding), 'decimal') : 0 }}
                  </td>
                  <td class="table-disabled table-cell-centered">
                    {{
                      lastLevel.finalPercentOutstanding > 0
                        ? $n(Number(lastLevel.finalPercentOutstanding), 'decimal')
                        : 0
                    }}
                  </td>
                  <td class="table-disabled table-cell-centered d-flex">
                    <ButtonAllNotReadonly
                      type="validation"
                      icon="add"
                      margin="no"
                      :disabled="rent.hasSimulationContract"
                      @click="postLevel"
                    />
                    <ButtonAllNotReadonly
                      type="validation"
                      icon="modify"
                      margin="no"
                      :disabled="rent.hasSimulationContract"
                      class="ml-1"
                      @click="editLastLevel"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <FieldCreator :form-data="formData" name="saleRate" form-ref="formrent" domain="rent" label-top />
            <FieldCreator :form-data="formData" name="monthly" form-ref="formrent" domain="rent" label-top />
          </div>
        </div>
        <div class="col-md-4">
          <div class="row text-left">
            <div class="col-md-8">
              <i class="fa fa-money-bill mr-1"></i>
              {{ $t('demand.fields.finance.amount.label') }}
            </div>
            <div class="col" e2e-data="rentAmount">{{ $n(Number(rent.amount), 'currency') }}</div>
          </div>
          <div v-if="conf.theme_dir !== 'yneia'" :class="'my-2 row text-left ' + profitabilityClass">
            <div class="col-md-8">
              <i class="fa fa-piggy-bank mr-1"></i>
              {{ $t('demand.fields.profitability.label') }}
            </div>
            <div class="col" e2e-data="profitability">{{ $n(Number(rent.margin), 'decimal') }} %</div>
          </div>
          <div v-if="conf.theme_dir !== 'yneia'" class="row text-left">
            <div class="col-md-8"></div>
            <div class="col" e2e-data="profitabilityDutyFree">
              {{ $n(Number(rent.profitability), 'currency') }} {{ $t('main.dutyFree') }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else #body>
      <div class="row justify-content-around mt-3">
        <div class="col-md-5 py-3 loading"></div>
        <div class="col-md-5 py-3 loading"></div>
      </div>
    </template>
    <template #footer>
      <div class="row w-100 justify-content-center">
        <div class="is-invalid font-weight-bold fs-16">
          {{ errorMessage }}
        </div>
      </div>
      <div class="row w-100 justify-content-center">
        <div class="col-md-10" v-if="activeLevel">
          <div :class="'d-flex justify-content-between'">
            <ButtonAllNotReadonly e2e-button="activateLinear" label="rent.button.initialize" @click="backToRent" />
            <ButtonAllNotReadonly
              type="success"
              e2e-button="validateLevel"
              :loading="sendingLevel"
              label="rent.button.levelValidate"
              @click="patchRent"
            />
          </div>
        </div>
        <div class="col-md-10" v-else>
          <div class="d-flex justify-content-between">
            <ButtonAllNotReadonly
              type="button"
              class="btn btn-primary"
              v-if="hasRole('ROLE_ADVANCE_RENT_SHOW')"
              e2e-button="activateLevel"
              label="rent.button.activeLevel"
              @click="activeLevelBtn"
            />
            <ButtonAllNotReadonly
              v-if="decisionId"
              type="success"
              e2e-button="calculate"
              label="button.calculate"
              :loading="sendingCalcul"
              @click="calculate"
            />
            <ButtonAllNotReadonly
              v-if="inContract"
              type="success"
              e2e-button="calculate"
              label="button.calculate"
              :loading="sendingCalcul"
              @click="calculateContract"
            />
          </div>
        </div>
        <div class="col-md-2">
          <ButtonAll type="info" e2e-button="close" label="button.close" @click="closeModal" />
        </div>
      </div>
    </template>
  </ModalDialog>
</template>
